// ======================================================================
// File Name       : UserSearch
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================
import React from 'react';
import { Form, FormControl, Col, Button } from 'react-bootstrap';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import PaginationCustom from '../../Pagination';
import { convertNodeGroupToNodeString } from '../../../utils/UserUtils';
import RenderField from '../../../utils/ReduxFormUtils';
import { SELECT_BOX_DATA } from '../../../constants/SelectBoxData';
import SelectGroupDlg from '../../../components/group/SelectUserGroupDialog';
import * as distributionAction from '../../../actions/report/DistributionAction';
import { USER_ATTRIBUTE_KEY_NUM_LIST } from '../../../constants/UserAttributeConstants';
import CustomButton from '../../button/CustomButton';

class UserSearch extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showSelectGroup: false,
    };
    this.showSelectGroupDlg = this.showSelectGroupDlg.bind(this);
    this.okSelectGroupDlg = this.okSelectGroupDlg.bind(this);
    this.cancelSelectGroupDlg = this.cancelSelectGroupDlg.bind(this);
    this.handleSearchBtn = this.handleSearchBtn.bind(this);
    this.getStartEndData = this.getStartEndData.bind(this);
    this.removeSelectedGroup = this.removeSelectedGroup.bind(this);
  }

  handleSearchBtn() {
    const { dispatch, distributionReport } = this.props;
    const { distributionReportDetail } = distributionReport;
    const { searchInfo } = distributionReportDetail;
    searchInfo.startPosition = 0;
    dispatch(distributionAction.updateDistributionReportDetailSearchInfo(searchInfo));
    // dispatch request search
    dispatch(distributionAction.searchUser());
  }

  getStartEndData(startPosition) {
    const { dispatch, distributionReport } = this.props;
    const { distributionReportDetail } = distributionReport;
    const { searchInfo } = distributionReportDetail;
    searchInfo.startPosition = startPosition;
    dispatch(distributionAction.updateDistributionReportDetailSearchInfo(searchInfo));
    dispatch(distributionAction.searchUser());
  }

  /**
   * Show select group dialog
   */
  showSelectGroupDlg() {
    const { dispatch, distributionReport } = this.props;
    const { distributionReportDetail } = distributionReport;
    const { searchInfo } = distributionReportDetail;
    searchInfo.showSelectGroup = true;
    dispatch(distributionAction.updateDistributionReportDetailSearchInfo(searchInfo));
    this.setState({ showSelectGroup: true });
  }

  /**
   * Handle event when click on キャンセル of select group dialog
   */
  cancelSelectGroupDlg() {
    const { dispatch, distributionReport } = this.props;
    const { distributionReportDetail } = distributionReport;
    const { searchInfo } = distributionReportDetail;
    searchInfo.showSelectGroup = false;
    dispatch(distributionAction.updateDistributionReportDetailSearchInfo(searchInfo));
    this.setState({ showSelectGroup: false });
  }

  /**
   * Handle event when click on OK of select group dialog
   *
   * @param {object} group
   */
  okSelectGroupDlg(group) {
    const { dispatch, distributionReport } = this.props;
    const { distributionReportDetail } = distributionReport;
    const { searchInfo, groupList } = distributionReportDetail;
    searchInfo.selectedGroup = {};
    if (group) {
      searchInfo.selectedGroup = group;
      searchInfo.groupName = group.groupName;
      if (searchInfo.selectedGroup && groupList && searchInfo.selectedGroup.groupSecernId) {
        const groupSecernId = searchInfo.selectedGroup.groupSecernId;
        searchInfo.groupName = convertNodeGroupToNodeString(groupSecernId, groupList);
      }
    }
    searchInfo.showSelectGroup = false;
    dispatch(distributionAction.updateDistributionReportDetailSearchInfo(searchInfo));
    this.setState({ showSelectGroup: false });
  }
  
  removeSelectedGroup() {
    const { dispatch, distributionReport } = this.props;
    const { distributionReportDetail } = distributionReport;
    const { searchInfo } = distributionReportDetail;
    searchInfo.selectedGroup = {};
    searchInfo.groupName = '';
    dispatch(distributionAction.updateDistributionReportDetailSearchInfo(searchInfo));
    this.setState({ showSelectGroup: false });
  }

  render() {
    const { dispatch, distributionReportSearch, distributionReport } = this.props;
    const { distributionReportDetail } = distributionReport;
    const { searchInfo, groupList, userListIds } = distributionReportDetail;
    const { recordNum } = userListIds;
    const { startPosition, selectedGroup, groupName } = searchInfo;
    const { showSelectGroup } = this.state;
    return (
      <Col sm={12} className="padding-left-right-clear">
        <p className="margin-top-10">検索する項目を指定してください</p>
        <Form onSubmit={(e) => { e.preventDefault(); this.handleSearchBtn(); }} className='form-horizontal'>
          <Form.Group className="form-info row" controlId="formHorizontalUserName">
            <Col as={Form.Label} sm={3}>ユーザー名(添削者)</Col>
            <Col sm={9} className="padding-right-15">
              <RenderField
                type="text"
                name="userName"
                label="レポート名"
                maxLength="256"
              />
            </Col>
          </Form.Group>
          <Form.Group className="form-info row">
            <Col as={Form.Label} sm={3}>
              所属グループ(添削者)
            </Col>
            <Col sm={9}>
              <Button
                variant="primary"
                className="btn-96"
                onClick={this.showSelectGroupDlg}
              >
                グループ選択
                </Button>
            </Col>
          </Form.Group>
          {(selectedGroup && selectedGroup.groupSecernId && groupName) &&
            <Form.Group className="form-info row" controlId="formHorizontalGroup">
              <Col sm={3}>
              </Col>
              <Col sm={7} as={Form.Label}>
                {groupName}
              </Col>
              <Col sm={2}>
                <Button variant="primary" className="btn-96 margin-left-15" onClick={this.removeSelectedGroup}>削除</Button>
              </Col>
            </Form.Group>}

          <Form.Group className="margin-top-10">
            <Col sm={12} className="text-center">
              {/* <Button bsStyle="primary" className="btn-96" type="submit"></Button> */}
              <CustomButton
                btnStyle="btn btn-primary btn-96"
                type="submit"
                text="検索"
                iconClass="bi bi-search"
              />
            </Col>
          </Form.Group>
          <Form.Group>
            <Col sm={12} className='margin-bottom-15'>
              <Col sm={5} className="padding-left-right-clear  margin-top-20">添削者一覧</Col>
            </Col>
          </Form.Group>
        </Form>
        <SelectGroupDlg
          showModal={showSelectGroup}
          selectedGroup={selectedGroup}
          groupList={groupList}
          onCancel={this.cancelSelectGroupDlg}
          onOK={this.okSelectGroupDlg}
        />
      </Col>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { form, distributionReport } = state;
  return {
    distributionReport,
  };
};

const form = reduxForm({ form: 'distributionReportUserSearchForm', touchOnChange: true });
export default connect(mapStateToProps)(form(UserSearch));
